import React, { useEffect, useState } from "react";
import "./cab.css";
import {
  ArrowLeft,
  Car,
  BarChart3,
  Clock,
  Clock3,
  CheckCircle,
  XCircle,
  Search,
  MapPin,
  Eye,
  ArrowRight,
  Wallet,
  TrendingUp
} from "lucide-react";

const API = "https://bodhimaram.onrender.com/api/cab";
const tabs = ["Recent", "Paid", "Pending", "Failed"];

const capitalize = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : "-";

const Cab = () => {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("Recent");
  const [search, setSearch] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [selected, setSelected] = useState(null);

  const [status, setStatus] = useState("paid");
  const [amount, setAmount] = useState("");
  const [mode, setMode] = useState("online");
  const [note, setNote] = useState("");

  /* ===== LOAD ===== */
  async function load() {
    await fetch(`${API}/init-current-month`, { method: "POST" });

    const res = await fetch(`${API}/payments`);
    const rows = await res.json();

    const currentMonth = new Date().getMonth() + 1;
    const prevMonth = currentMonth - 1;

    const map = {};

    rows.forEach((r) => {
      if (!map[r.student]) {
        map[r.student] = {
          id: r.id,
          student: r.student,
          area: r.area,
          amount: r.amount,
          prevMonth: "-",
          currMonth: "-",
        };
      }

      if (r.month === currentMonth) {
        map[r.student].currMonth = capitalize(r.payment_status);
      }

      if (r.month === prevMonth) {
        map[r.student].prevMonth = capitalize(r.payment_status);
      }
    });

    setData(Object.values(map));
  }

  useEffect(() => {
    load();
  }, []);

  /* ===== FILTER (FINAL & CORRECT) ===== */
  const filtered = data.filter((d) => {
    if (!d.area.toLowerCase().includes(search.toLowerCase())) return false;

    if (activeTab === "Recent") return true;

    return d.currMonth.toLowerCase() === activeTab.toLowerCase();
  });

  /* ===== OPEN POPUP ===== */
  const openPopup = (row) => {
    setSelected(row);
    setStatus(row.currMonth.toLowerCase());
    setAmount(row.amount);
    setMode("online");
    setNote("");
    setShowPopup(true);
  };

  /* ===== SAVE ===== */
  const save = async () => {
    await fetch(`${API}/payments/${selected.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        status,
        mode,
        note,
      }),
    });

    setShowPopup(false);
    load();
  };

  return (
    <div className="cab-container">
      <h2>Monthly Cab Payments</h2>

<div className="mobileTabs">

  <div
    className={`mobileTab ${activeTab==="Recent"?"active":"blues"}`}
    onClick={()=>setActiveTab("Recent")}
  >
    {/* <span className="tabDot recent"></span> */}
    <Clock className="blues"/>
    Recent
  </div>

  <div
    className={`mobileTab ${activeTab==="Paid"?"activeg":"greens"}`}
    onClick={()=>setActiveTab("Paid")}
  >
    {/* <span className="tabDot paid"></span> */}
    < CheckCircle className="greens"/>
    Paid
  </div>

  <div
    className={`mobileTab ${activeTab==="Pending"?"activec":"coffe"}`}
    onClick={()=>setActiveTab("Pending")}
  >
    {/* <span className="tabDot pending"></span> */}
    <Clock3 className="coffe"/>
    Pending
  </div>

  <div
    className={`mobileTab  ${activeTab==="Failed"?"activer":"reds"}`}
    onClick={()=>setActiveTab("Failed")}
  >
    {/* <span className="tabDot failed"></span> */}
    <XCircle className="reds"/>
    Failed
  </div>

</div>

      <div className="tabs">
        {tabs.map((t) => (
          <button
            key={t}
            className={activeTab === t ? "active" : ""}
            onClick={() => setActiveTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

    
      <div className="search-container-cab">
  <Search size={20} className="search-icon-cab" />

  <input
    className="search-input-cab"
    placeholder="Search Stop Location"
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />
</div>

<div className="cabSummaryCard">

  <div className="summaryBox">
  <div className="wallet_icon">
     {/* < Wallet className="Wallet_i" size={32}/> */}
      < TrendingUp size={32} className="Wallet_i"/>
     </div>
   <div>
    <span>Total Students</span>

    <h3>{filtered.length}</h3>
    </div>
  </div>

  <div className="summaryBoxs">
   

   <div>
    <span>This Month Collection</span>

    <h3>
      ₹{
        filtered
          .filter(
            x =>
              x.currMonth.toLowerCase() ===
              "paid"
          )
          .reduce(
            (s,x) =>
              s + Number(x.amount),
            0




            
          )
      }
    </h3>

    </div>
     <div className="TrendingUp_icon">
       {/* < TrendingUp size={30} className="TrendingUp"/> */}
       < Wallet className="TrendingUp" size={30}/>

       </div>
  </div>

</div>
{/* MOBILE VIEW */}
<div className="mobileCabList">

  {filtered.map((r, i) => (

    <div
      key={i}
      className="mobileCabCard"
    >

      {/* LEFT */}
      <div className="mobileCabLeft">

        <div className="cabNumber">
          {String(i + 1).padStart(2, "0")}
        </div>

        {/* <div className="cabAvatar">
          {r.student?.charAt(0)}
        </div> */}

        <div className="cabInfo">

          <h4>{r.student}</h4>

          <p>< MapPin size={15} className="mappin"/>{r.area}</p>

          <small>
            Class : {r.class_name || "LKG"}
          </small>

        </div>

      </div>

      {/* RIGHT */}
      <div className="mobileCabRight">
 <span
      className={`statusBadge ${r.prevMonth.toLowerCase()}`}
    >
      {r.prevMonth}
    </span>

        <div
          className={`mobileStatus ${r.currMonth.toLowerCase()}`}
        >
        
          {r.currMonth}
        </div>

        <div className="mobileAmount">
          ₹{r.amount}
        </div>

        <button
          className="mobileCabAction"
          onClick={() => openPopup(r)}
        >
          {/* ➜ */}
          <ArrowRight/>
          
        </button>

      </div>

    </div>

  ))}

</div>


<div className="cab-table-wrap">
  <table className="cab-table">
    <thead>
      <tr>
        <th>#</th>
        <th>Student</th>
        <th>Stop</th>
        <th>Prev</th>
        <th>Current</th>
        <th>Amount</th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      {filtered.length ? (
        filtered.map((r, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{r.student}</td>
            <td>{r.area}</td>
            <td className={`status ${r.prevMonth.toLowerCase()}`}>{r.prevMonth}</td>
            <td className={`status ${r.currMonth.toLowerCase()}`}>{r.currMonth}</td>
            <td>₹{r.amount}</td>
            <td>
              
                <button onClick={() => openPopup(r)}>➜</button>
             
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="7" style={{ textAlign: "center" }}>
            No records found
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>



      {showPopup && (
        <div className="cab-popup-overlay">
          <div className="cab-popup">
            <h3>Update Payment</h3>

            <label>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
              <option value="failed">Failed</option>
            </select>

            {status === "paid" && (
              <>
                <label>Amount</label>
                <input value={amount} onChange={(e) => setAmount(e.target.value)} />

                <label>Mode</label>
                <select value={mode} onChange={(e) => setMode(e.target.value)}>
                  <option value="online">Online</option>
                  <option value="cash">Cash</option>
                </select>

                <label>{mode === "online" ? "UTR No" : "Cash Notes"}</label>
                <input value={note} onChange={(e) => setNote(e.target.value)} />
              </>
            )}

            <div className="popup-actions">
              <button onClick={() => setShowPopup(false)}>Cancel</button>
              <button onClick={save}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cab;
